import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Nav";
import Footer from "../components/Footer";

const Checkout = () => {
  const { cartItems, clearCart, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
    address: "",
    notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successTotal, setSuccessTotal] = useState(0);
  const [successName, setSuccessName] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (cartItems.length === 0) {
      alert("Your cart is empty!");
      return;
    }

    setLoading(true);

    try {
      const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

      const orderData = {
        customer: formData,
        items: cartItems.map((item) => ({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity,
          image: item.image || "",
        })),
        total,
        status: "جديد",
        createdAt: serverTimestamp(),
      };

      await addDoc(collection(db, "orders"), orderData);

      setSuccessTotal(total);
      setSuccessName(formData.name);

      clearCart();
      setFormData({ name: "", phone: "", city: "", address: "", notes: "" });
      setSuccess(true);

      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (error) {
      console.error("Error adding order: ", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const totalPrice = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  if (success) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          background: "linear-gradient(135deg, #f5f0ea, #d4af37)",
          color: "#5a3e36",
          fontFamily: "Tahoma, sans-serif",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>✅ Order Placed Successfully!</h1>
        <p style={{ fontSize: "18px", marginBottom: "20px" }}>
          Thank you, {successName || "Customer"}!<br />
          Your order total is {successTotal.toLocaleString()} EGP.<br />
          You will be redirected to the homepage shortly.
        </p>
        <div
          style={{
            width: "80px",
            height: "80px",
            border: "6px solid #fff",
            borderTop: "6px solid #5a3e36",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto",
          }}
        />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div style={{ minHeight: "100vh", backgroundColor: "#f5f0ea", padding: "50px 20px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {/* Checkout Form */}
          

          {/* Cart Summary */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
              padding: "20px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
              border: "2px solid #d4af37",
            }}
          >
            <h3 style={{ color: "#5a3e36", textAlign: "center", marginBottom: "20px" }}>Your Cart</h3>
            {cartItems.length === 0 ? (
              <p style={{ textAlign: "center" }}>Your cart is empty</p>
            ) : (
              <>
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "15px",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "10px",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {item.image && (
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
                      />
                    )}
                    <div style={{ flex: 1 }}>
                      <p style={{ margin: 0, fontWeight: "bold", color: "#5a3e36" }}>{item.name}</p>
                      <p style={{ margin: "5px 0" }}>Price: {item.price} EGP</p>
                      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          disabled={item.quantity <= 1}
                          style={{
                            padding: "3px 8px",
                            borderRadius: "5px",
                            border: "1px solid #5a3e36",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                          }}
                        >
                          -
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          style={{
                            padding: "3px 8px",
                            borderRadius: "5px",
                            border: "1px solid #5a3e36",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                          }}
                        >
                          +
                        </button>
                        <button
                          onClick={() => removeFromCart(item.id)}
                          style={{
                            padding: "3px 8px",
                            borderRadius: "5px",
                            border: "1px solid red",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            color: "red",
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{ textAlign: "right", fontWeight: "bold", marginTop: "15px", color: "#5a3e36" }}>
                  Total: {totalPrice} EGP
                </div>
                <div style={{ textAlign: "center", marginTop: "10px", color: "#d4af37", fontWeight: "bold" }}>
                  Shipping: Free 🚚
                </div>
              </>
            )}
          </div>
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
              padding: "30px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
              border: "2px solid #d4af37",
            }}
          >
            <h2 style={{ textAlign: "center", color: "#5a3e36", marginBottom: "25px" }}>Checkout</h2>
            <form onSubmit={handleSubmit}>
              {["name", "phone", "city", "address"].map((field) => (
                <div key={field} style={{ marginBottom: "15px" }}>
                  <label style={{ display: "block", fontWeight: "bold", color: "#5a3e36" }}>
                    {field === "name"
                      ? "Full Name:"
                      : field === "phone"
                      ? "Phone Number:"
                      : field === "city"
                      ? "City / State:"
                      : "Address:"}
                  </label>
                  <input
                    type={field === "phone" ? "tel" : "text"}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      marginTop: "5px",
                    }}
                  />
                </div>
              ))}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontWeight: "bold", color: "#5a3e36" }}>Notes (Optional):</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    marginTop: "5px",
                    minHeight: "60px",
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: "100%",
                  padding: "12px",
                  backgroundColor: "#5a3e36",
                  color: "#fff",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "10px",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  transition: "0.3s",
                }}
                onMouseOver={(e) => !loading && (e.currentTarget.style.backgroundColor = "#d4af37")}
                onMouseOut={(e) => !loading && (e.currentTarget.style.backgroundColor = "#5a3e36")}
              >
                {loading ? "Processing..." : "Place Order"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
